import React, { createRef } from 'react';
import { IonInput, IonChip, IonSearchbar, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import { Doughnut } from 'react-chartjs-2';
import CalendarHeatmap from 'react-calendar-heatmap';

import 'react-calendar-heatmap/dist/styles.css';
import Utilities from '../Utilities';
import "../styles/ChartActivity.scss";
import { chevronBack, chevronForward } from 'ionicons/icons';
import ReactTooltip from 'react-tooltip';

class ChartActivity extends React.Component {

    componentDidMount() {
        this.calculateYear(new Date().getFullYear());
    }

    calculateYear = (year) => {

        let periods = [
            [new Date(year, 0, 1), new Date(year, 4, 1)],
            [new Date(year, 4, 1), new Date(year, 8, 1)],
            [new Date(year, 8, 1), new Date(year+1, 0, 1)]
        ]

        let rangeValuePeriods = [];

        for (let i = 0; i < periods.length; i++) {
            let start = new Date(periods[i][0]);
            let end = new Date(periods[i][1]);
            let rangeValues = []
            while (start < end) {
                let dateHash = Utilities.formatDate(start, "YYYY-MM-DD");
                let count = this.props.values[dateHash] || 0;
                rangeValues.push({
                    date: new Date(start),
                    count: count
                })
                start = Utilities.dateAdd(start, "day", 1);
            }
            rangeValuePeriods.push(JSON.parse(JSON.stringify(rangeValues)));
            // rangeValuePeriods = rangeValuePeriods.concat(rangeValues);
        }

        this.setState({
            rangeValuePeriods: rangeValuePeriods,
            periods: periods,
            year: year
        })
    }

    render() {

        if (!this.state || !this.state.year)
            return null;

        return (
            <div 
                className="chart-wrapper chart-activity"
                style={{ borderTop: this.props.borderTop, marginTop: 0 }}
            >
                <h2>{this.props.title}</h2>
                <div className="options">
                    <button onClick={() => { this.calculateYear(this.state.year-1); }}>
                        <IonIcon style={{ marginRight: 4 }} icon={chevronBack} />
                        <span>{(this.state.year-1)}</span>
                    </button>
                    <button>
                        <span>{this.state.year}</span>
                    </button>
                    <button onClick={() => { this.calculateYear(this.state.year+1); }}>
                        <span>{(this.state.year+1)}</span>
                        <IonIcon style={{ marginLeft: 4 }} icon={chevronForward} />
                    </button>
                </div>
                <div>
                    { this.state.periods.map((period, i) => {
                        return (
                            <CalendarHeatmap
                                startDate={Utilities.dateSub(period[0], "day", 8)}
                                endDate={period[1]}
                                values={this.state.rangeValuePeriods[i]}
                                classForValue={value => {
                                    return `color-github-own-${value ? value.count : 0}`;
                                }}
                                tooltipDataAttrs={value => {
                                    if (!value || !value.date)
                                        return null
                                    return {
                                      'data-tip': `${Utilities.formatDate(value.date, "YYYY-MM-DD")}: ${
                                        value.count
                                      } ${window.ln.reviews}`,
                                    };
                                  }}
                                  horizontal={true}
                                onClick={() => {

                                }}
                                showWeekdayLabels={false}
                            />
                        )
                    }) }
                    <ReactTooltip />
                </div>
            </div>
        );
    }

};


export default withIonLifeCycle(ChartActivity);
